import React from 'react';

function TerminalMouseOver(props) {
  // console.log('Props in Terminal Mouse Over-----', props);
  return (
    <div
      className={'mouseover-popups terminal-mouseover font9 '}
      // className="mouseover-popups terminal-mouseover nowrap font9"
      ref={el => {
        props.terminalEl[props.service.id + '1'] = el;
      }}
      style={{
        // minWidth: props.label && props.label.length > 25 ? 260 : 200,
        minWidth: 270,
        maxWidth: 400,
        marginTop:
          '-' +
          (props.terminalEl[props.service.id + '1']
            ? props.terminalEl[props.service.id + '1'].clientHeight / 2
            : 0) +
          'px',
      }}
      // style={{ minWidth: 160, marginTop: 0 }}
    >
      <div style={{ lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
        {/* <div> */}
        <span>
          {props.direction == 1
            ? (props.terminals &&
                props.terminals[Number(props.service.boarding_stages.split('|')[0])]) ||
              props.label
            : (props.terminals &&
                props.terminals[Number(props.service.dropoff_stages.split('|')[0])]) ||
              props.label}
        </span>
      </div>
      <span
        style={props.label && props.label.length > 30 ? { top: '20%' } : { top: '50%' }}
        className="primary-triangle"
      >
        {' '}
      </span>
    </div>
  );
}

export default TerminalMouseOver;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/ServiceItem/components/TerminalMouseOver.js